export const string = val => typeof val === 'string';
export const hasData = val => val && val.toString().length > 0;
export const minLength = (length, val) => val.length >= length;
export const isEmail = val => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val.toLowerCase());
export const isNumber = val => !isNaN(val);
export const isBlankSpace = val => /^\s+$/.test(val);
export const isArray = val => {
  if (!Array.isArray) {
      return Object.prototype.toString.call(val) === '[object Array]';
  }else{
     return Array.isArray(val);
  }
}
/**
 * Devuelve true si el objeto esta vacio o es null
 * @param {object} obj 
 */
export const isEmptyObj = obj => {
  if(obj){
    for(var prop in obj) {
      if(Object.prototype.hasOwnProperty.call(obj, prop))
          return false;
    }
  }
  return true;
}
